// Removed drag-drop-touch polyfill - implementing native touch drag instead
import { DisplayMode, Engine } from "excalibur";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import HandDisplayContainer from "./components/HandDisplayContainer";
import ResourceDisplayContainer from "./components/ResourceDisplayContainer";
import { InitialFlow } from "./engine/initialFlow";
import { StartGameFlow } from "./flows/startGameFlow";
import { MyLevel } from "./level";
import "./style.css";

// Goal is to keep main.ts small and just enough to configure the engine

export const Width = 256,
  Height = 320;

const game = new Engine({
  viewport: {
    width: Width, // Logical width and height in game pixels
    height: Height,
  },
  resolution: {
    width: Width,
    height: Height,
  },
  displayMode: DisplayMode.FitContainerAndFill,
  pixelArt: true, // pixelArt will turn on the correct settings to render pixel art without jaggies or shimmering artifacts
  canvasElementId: "game-container",
  scenes: {
    start: MyLevel,
  },
  suppressPlayButton: true,
  // physics: {
  //   solver: SolverStrategy.Realistic,
  //   substep: 5 // Sub step the physics simulation for more robust simulations
  // },
  // fixedUpdateTimestep: 16 // Turn on fixed update timestep when consistent physic simulation is important
});

new InitialFlow(game.clock, new StartGameFlow(game));

// Expose game instance for testing
(window as unknown as Record<string, unknown>).game = game;

// Expose level methods for debugging URL state
(window as unknown as Record<string, unknown>).getShareableUrl = async () => {
  const level = game.currentScene as unknown as Record<string, unknown>;
  if (level.generateShareableUrl && typeof level.generateShareableUrl === 'function') {
    return await (level.generateShareableUrl as () => Promise<string>)();
  }
  return 'Level not loaded';
};

(window as unknown as Record<string, unknown>).captureStateForTest = () => {
  const level = game.currentScene as unknown as Record<string, unknown>;
  if (level.captureStateForTest && typeof level.captureStateForTest === 'function') {
    return (level.captureStateForTest as () => unknown)();
  }
  return 'Level not loaded';
};

const root = createRoot(document.getElementById("ui-root") as HTMLElement);
root.render(
  <StrictMode>
    <App game={game} />
  </StrictMode>,
);

// Mount ResourceDisplay with real game data
const resourceRoot = createRoot(
  document.getElementById("resource-display") as HTMLElement,
);

resourceRoot.render(
  <StrictMode>
    <ResourceDisplayContainer game={game} />
  </StrictMode>,
);

// Mount HandDisplay with real game data
const handRoot = createRoot(
  document.getElementById("hand-display") as HTMLElement,
);

handRoot.render(
  <StrictMode>
    <HandDisplayContainer game={game} />
  </StrictMode>,
);
